import type { DefaultDashboardDefinition } from './dashboard-definition';

export const expensesDashboard: DefaultDashboardDefinition = {
  id: "expenses.main",
  appId: "expenses",
  name: "Expenses dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: "expenses.spend-trend.default",
      widgetId: "expenses.spend-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "expenses.claim-trend.default",
      widgetId: "expenses.claim-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "expenses.total.default",
      widgetId: "expenses.total",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "expenses.claim-count.default",
      widgetId: "expenses.claim-count",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "expenses.reimbursable.default",
      widgetId: "expenses.reimbursable",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "expenses.status-list.default",
      widgetId: "expenses.status-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "expenses.category-report.default",
      widgetId: "expenses.category-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
